import React, { FC, ReactNode } from "react";
import SideBar from "./SideBar";
import View from "./View";
import TopNav from "./TopNav";
import Drawer from "./Drawer";


const Layout: FC<{ children: ReactNode }> = ({ children }) => {
  return (
      <div className="flex flex-row w-full h-full bg-neutral-800">
        {/* <SideBar /> */}
        <div className="w-full h-full flex flex-col">
          <TopNav />
          <div className="w-full h-full flex flex-row relative">
            {children}

            <Drawer />
          </div>
        </div>
      </div>
  );
};

export default Layout;
